export default {
  meta: {
    title: '系统管理-无意义',
  },
};
